import React, { useState } from 'react';
import { KPICards } from '../components/KPICards';
import { TicketTable } from '../components/TicketTable';
import { TeamWorkload } from '../components/TeamWorkload';
import { TrendAnalytics } from '../components/TrendAnalytics';
import { RefreshCwIcon } from 'lucide-react';
import { mockTickets, Ticket } from '../data/mockData';
interface DashboardProps {
  activePage: string;
}
const pageTitles: Record<string, string> = {
  Dashboard: 'MortgagePros Service Dashboard',
  Tickets: 'Case Management',
  Team: 'Operations Team',
  Analytics: 'MortgagePros Insights'
};
export function Dashboard({
  activePage
}: DashboardProps) {
  const [tickets, setTickets] = useState<Ticket[]>(mockTickets);
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <div className="mx-auto max-w-[1600px] space-y-6 bg-white p-8" data-id="element-318" data-mp="1wf80llyhxc26">
      <div className="flex flex-col md:flex-row md:items-center justify-between" data-id="element-319" data-mp="1rd8x8c2raf58">
        <div data-id="element-320" data-mp="21olmse8gwwj7">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#0d4f8b]" data-id="element-321" data-mp="21ovec695vbr0">
            MortgagePros
          </p>
          <h1 className="mt-1 text-2xl font-bold text-slate-900" data-id="element-322" data-mp="26quhbf0zo6nf">
            {pageTitles[activePage] || 'MortgagePros Service Dashboard'}
          </h1>
          <p className="mt-1 text-sm text-slate-500" data-id="element-323" data-mp="2fppmcnsarap5">{today}</p>
        </div>
        <div className="mt-4 md:mt-0 flex items-center space-x-4" data-id="element-324" data-mp="1izfcnflqpd90">
          <span className="flex items-center text-sm text-slate-500" data-id="element-325" data-mp="1ix2mwg9qpyle">
            <span className="mr-2 h-2 w-2 rounded-full bg-[#0d4f8b]" data-id="element-326" data-mp="1nz1mdf2d0bd2"></span>
            MortgagePros systems operational
          </span>
          <button className="flex items-center space-x-2 rounded-lg bg-[#0d4f8b] px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#003f75] focus:outline-none focus:ring-2 focus:ring-[#0d4f8b] focus:ring-offset-2" data-id="element-327" data-mp="1ry0q4wccu22x">
            <RefreshCwIcon className="h-4 w-4" data-id="element-328" data-mp="1497smvg33m67" />
            <span data-id="element-329" data-mp="147wp8wqjwgfm">Refresh</span>
          </button>
        </div>
      </div>

      {activePage === 'Dashboard' && <>
          <KPICards tickets={tickets} data-id="element-330" data-mp="22mls01co9nd6" />
          <TicketTable tickets={tickets} onTicketsChange={setTickets} data-id="element-331" data-mp="22lkdfmwg6iqp" />
          <TeamWorkload tickets={tickets} data-id="element-332" data-mp="2hb9l80z1pkzy" />
          <TrendAnalytics data-id="element-333" data-mp="2hd2pj9m6rt4s" />
        </>}

      {activePage === 'Tickets' && <TicketTable tickets={tickets} onTicketsChange={setTickets} data-id="element-334" data-mp="2cceywp1vdeb3" />}

      {activePage === 'Team' && <TeamWorkload tickets={tickets} data-id="element-335" data-mp="1omkoee50w1u0" />}

      {activePage === 'Analytics' && <TrendAnalytics data-id="element-336" data-mp="1jo9czyz2xj9o" />}

      <footer className="py-4 text-center text-xs text-slate-400" data-id="element-337" data-mp="1jp2ccevpl6hs">
        MortgagePros Service Operations &copy; {new Date().getFullYear()} · mtgpros.com
      </footer>
    </div>;
}